export const CIAN_GPT_POPUP_TOPIC = 'cianGptPopup';
